/**
 * 화면이 고를 수 있는 로케일. 서버가 주는 `lang` 도 이 안일 때만 적용한다.
 *
 * import 가 없는 파일이다 — 네이티브 셸(`apps/mobile`)도 이것을 읽는데, `./index.ts` 는
 * i18next·`window` 를 끌고 와 RN 번들에 넣을 수 없다.
 */
/** `zh` 는 간체다 — 번체 기기(`zh-Hant`·`zh-TW`)도 이 사전을 받는다. */
export const LANGUAGES = ['ko', 'en', 'zh'] as const;

export type Language = (typeof LANGUAGES)[number];

/** 웹 i18next 의 `fallbackLng` 이자, 네이티브가 고를 말이 없을 때의 값. */
export const FALLBACK_LANGUAGE: Language = 'ko';
